<template>
    <div class="vue-features-navigation cy-common-wrapper">
        <div class="nav-title">{{ navTitle }}</div>
        <div class="links-wrapper">
            <a :href="rootHref==='/' ? overviewLink : rootHref + overviewLink" :class="{ 'features-link': true, 'link-active': activeLink === overviewLink}">{{ overviewTitle }}</a>
            <a :href="rootHref==='/' ? featuresLink : rootHref + featuresLink" :class="{ 'features-link': true, 'link-active': activeLink === featuresLink}">{{ featuresTitle }}</a>
            <a :href="rootHref==='/' ? specsLink : rootHref + specsLink" :class="{ 'features-link': true, 'link-active': activeLink === specsLink}">{{ specsTitle }}</a>
            <a :href="rootHref==='/' ? accessoriesLink : rootHref + accessoriesLink" :class="{ 'features-link': true, 'link-active': activeLink === accessoriesLink}">{{ accessoriesTitle }}</a>
            <a :href="rootHref==='/' ? reviewLink : rootHref + reviewLink" :class="{ 'features-link': true, 'link-active': activeLink === reviewLink}">{{ reviewTitle }}</a>
        </div>
        <div class="buttons-wrapper">
            <div class="button-test-ride alink" v-on:click="testRideClick">{{ testRideTitle }}</div>
            <a class="button-order-now" :href="rootHref==='/' ? orderNowLink : rootHref + orderNowLink">{{ orderNowTitle }}</a>
        </div>
    </div>
</template>

<script>
export default {
    name: 'FeaturesNavigation',
    created() {
    },
    mounted () {
        this.$nextTick(() => {
            const targetDom = document.querySelector('.features-link.link-active');
            const coverDom = document.querySelector('.vue-features-navigation');
            const halfWidth = coverDom.offsetWidth / 2;
            coverDom && targetDom && coverDom.scrollTo(targetDom.offsetLeft - halfWidth, 0);
        })
    },
    computed: {
        rootHref() {
            return this.locale === 'en' ? '/' : `/${this.locale}`;
        }
    },
    data() {
        const { 
            navTitle,
            overviewTitle, 
            overviewLink,
            featuresTitle,
            featuresLink,
            specsTitle,
            specsLink,
            accessoriesTitle,
            accessoriesLink,
            testRideTitle,
            orderNowTitle,
            orderNowLink,
            reviewTitle,
            reviewLink
        } = window.featuresNavConfig || {};
        const { locale = 'en' } = window.globalNavConfig || {};
        const activeLink = [overviewLink, featuresLink, specsLink, accessoriesLink, reviewLink].find(link => window.location.pathname.endsWith(link));
        return {
            navTitle,
            activeLink,
            overviewTitle,
            overviewLink,
            featuresTitle,
            featuresLink,
            specsTitle,
            specsLink,
            accessoriesTitle,
            accessoriesLink,
            testRideTitle,
            orderNowTitle,
            orderNowLink,
            reviewTitle,
            reviewLink,
            locale
        }
    },
    methods: {
        testRideClick() {
            let actionSheetDom = document.getElementById('shopify-section-action-sheet')
            actionSheetDom.querySelector('.action-sheet_overlay').style.opacity = '0.5'
            actionSheetDom.querySelector('.action-sheet_overlay').style.visibility = 'visible'
            actionSheetDom.querySelector('.action-sheet').style.visibility = 'visible'
        }
    }
}
</script>